import { createSelector } from '@reduxjs/toolkit';
import {
  calculateDeviceSize,
  mobileDeviceSizes,
} from 'src/utils/calculateDeviceSize';

import { StoreState } from '../types';

import { AgentState } from './types';

export const getAgentState = (state: StoreState): AgentState => state.agent;

export const getDeviceWidth = createSelector(
  getAgentState,
  agent => agent.width,
);

export const getDeviceSize = createSelector(
  getDeviceWidth,
  calculateDeviceSize,
);

export const getIsMobile = createSelector(getDeviceSize, size =>
  mobileDeviceSizes.has(size),
);

export const getIsTouchscreen = createSelector(
  getAgentState,
  agent => agent.touch,
);

export const getIsMobileWithTouchscreen = createSelector(
  getIsMobile,
  getIsTouchscreen,
  (isMobile, isTouchscreen) => isMobile && isTouchscreen,
);

export const getIsDesktop = createSelector(getIsMobile, isMobile => !isMobile);

export const getIsLandscapeMobile = createSelector(
  getAgentState,
  agent => agent.width > agent.height && agent.height <= 480,
);

export const getHeaderHeight = createSelector(
  getAgentState,
  agent => agent.headerHeight,
);
